import Grid from '@/global/components/ui/Grid'
import { FormField } from 'global/components/Form'
import IconeAjuda from 'global/components/IconeAjuda'
import Dialog from 'global/guides/Dialog'
import { useValeAlimentacaoOutletContext } from 'pages/RelatorioValeAlimentacao.context'
import { useNavigate, useSearchParams } from 'react-router-dom'
import {
    ValeAlimentacao,
    createValeAlimentacaoSchema,
    valeAlimentacao,
    valoresValeAlimentacao,
} from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'

export default function ConfiguracaoValeAlimentacao() {
    const [searchParam] = useSearchParams()
    const navigate = useNavigate()
    const empresaId = useStore(state => state.companyId)
    const { mutate: createConfig } = valeAlimentacao.mutations.useCreate({
        invalidateQuery: true,
    })
    const { mutate: updateConfig } = valeAlimentacao.mutations.useUpdate({
        invalidateQuery: true,
    })

    function handleClose() {
        const voltar = searchParam.get('voltar')
        if (voltar) navigate(voltar)
        else navigate(-1)
    }

    const {
        Config: { data: configuracao },
    } = useValeAlimentacaoOutletContext()

    function handleSubmit(data: ValeAlimentacao) {
        const callbacks = {
            onSuccess: async () => {
                await valoresValeAlimentacao.invalidateQueries()
                toast.success(
                    `Configuração ${
                        configuracao ? 'atualizada' : 'cadastrada'
                    } com sucesso`,
                )
                handleClose()
            },
            onError: (err: any) => {
                toast.error(err.message)
            },
        }

        if (configuracao) {
            updateConfig(
                {
                    ...data,
                    id: configuracao.id,
                },
                callbacks,
            )
        } else {
            createConfig(data, callbacks)
        }
    }

    return (
        <Dialog.Root
            onClose={handleClose}
            onSubmit={handleSubmit}
            schema={createValeAlimentacaoSchema}
            defaultValues={{
                empresaId,
                ...configuracao,
            }}
            width="lg"
        >
            <Dialog.Title>
                {configuracao
                    ? 'Editar configuração'
                    : 'Cadastrar configuração'}
            </Dialog.Title>
            <Dialog.Content>
                <Grid container>
                    <Grid item xs={12}>
                        <FormField
                            name="valorVale"
                            label="Valor do vale alimentação"
                            placeholder='Ex: "50.00"'
                            type="number"
                            startAdornment={
                                <span className="text-sm text-muted-foreground">
                                    R$
                                </span>
                            }
                            endAdornment={
                                <IconeAjuda>
                                    É o valor integral do vale alimentação que o
                                    funcionário receberá caso trabalhe o número
                                    de horas mínimo.
                                </IconeAjuda>
                            }
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <FormField
                            name="minimoHorasValorIntegral"
                            label="Horas mínimas"
                            type="number"
                            placeholder='Ex: "6"'
                            endAdornment={
                                <div className="inline-flex items-baseline">
                                    <span className="text-muted-foreground">
                                        h
                                    </span>
                                    <IconeAjuda>
                                        É o valor mínimo de horas que o
                                        funcionário deve trabalhar para receber
                                        o valor integral do vale alimentação.
                                        Caso o funcionário trabalhe menos do que
                                        esse valor, ele receberá o valor
                                        proporcional a porcentagem mínima.
                                    </IconeAjuda>
                                </div>
                            }
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <FormField
                            name="maximoHorasValorIntegral"
                            label="Horas máximas"
                            type="number"
                            placeholder='Ex: "8"'
                            endAdornment={
                                <div className="inline-flex items-baseline">
                                    <span className="text-muted-foreground">
                                        h
                                    </span>
                                    <IconeAjuda>
                                        É o valor máximo de horas que o
                                        funcionário deve trabalhar para receber
                                        o valor integral do vale alimentação.
                                        Caso o funcionário trabalhe mais do que
                                        esse valor, ele receberá o valor
                                        proporcional a porcentagem máxima.
                                    </IconeAjuda>
                                </div>
                            }
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <FormField
                            name="porcentagemValorMinimo"
                            label="Porcentagem mínima"
                            type="number"
                            placeholder='Ex: "50"'
                            endAdornment={
                                <div className="inline-flex items-baseline">
                                    <span className="text-muted-foreground">
                                        %
                                    </span>
                                    <IconeAjuda>
                                        É a porcentagem mínima que o funcionário
                                        receberá caso trabalhe menos do que o
                                        número de horas mínimo.
                                    </IconeAjuda>
                                </div>
                            }
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <FormField
                            name="porcentagemValorMaximo"
                            label="Porcentagem máxima"
                            type="number"
                            placeholder='Ex: "120"'
                            endAdornment={
                                <div className="inline-flex items-baseline">
                                    <span className="text-muted-foreground">
                                        %
                                    </span>
                                    <IconeAjuda>
                                        É a porcentagem máxima que o funcionário
                                        receberá caso trabalhe mais do que o
                                        número de horas máximo.
                                    </IconeAjuda>
                                </div>
                            }
                        />
                    </Grid>
                </Grid>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
